import { CheckoutStep } from "src/components/checkout/state/checkoutStageStore"
import { trackCheckoutStep } from "src/tracking/events"
import { createPersistentStore } from "src/utilities/localStorage/create"

type State = {
  active: boolean
  errorMessage: string | null
  wcOrderId: number | null
  paypalTransactionId: string | null
  email: string | null
}

const defaultState: State = {
  active: false,
  errorMessage: null,
  wcOrderId: null,
  paypalTransactionId: null,
  email: null,
}

const store = createPersistentStore(() => defaultState, {
  name: "express-checkout",
  partialize: (state) => {
    return {
      wcOrderId: state.wcOrderId,
      paypalTransactionId: state.paypalTransactionId,
      email: state.email,
    }
  },
})

export function useExpressCheckoutState() {
  return store()
}

export function getExpressCheckoutState() {
  return store.getState()
}

export function setExpressCheckoutActive(newActive: boolean) {
  const oldActive = store.getState().active

  if (newActive === oldActive) {
    store.setState({ active: newActive, wcOrderId: null, paypalTransactionId: null })
  }

  if (newActive) {
    trackCheckoutStep(CheckoutStep.ShippingInfo)
    trackCheckoutStep(CheckoutStep.PaymentInfo)
  }
}

export function setExpressCheckoutErrorMessage(errorMessage: string | null) {
  store.setState({ errorMessage })
}

export function setExpressCheckoutPayPalRefs({
  wcOrderId,
  paypalTransactionId,
  email,
}: {
  wcOrderId: number
  paypalTransactionId: string
  email: string
}) {
  store.setState({ wcOrderId, paypalTransactionId, email })
}

export function resetExpressCheckout() {
  const replace = true
  store.setState(defaultState, replace)
}
